import * as React from 'react'
import { PostWidgetCard, WidgetCardBaseProps } from "../../../../types"
import MobilityHelper from '../../../../helpers/MobilityHelper'
import styled from 'styled-components'

const Container = styled.a`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.08) 0px 0px 0px 1px, rgba(0, 0, 0, 0.06) 0px 2px 8px;
  transition: box-shadow 150ms;
  background-color: rgb(255, 255, 255);
  text-decoration: none;
  cursor: pointer;
`

const Cover = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid rgb(229, 229, 229);

  img {
    display: block;
    width: 100%;
    height: auto;
    border-radius: 10px 10px 0px 0px;
    overflow: hidden;
  }
`

const Section = styled.div`
  flex: 1 1 0%;
  display: flex;
  flex-direction: column;
  padding: 16px 20px;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const Title = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  margin-bottom: 4px;
  color: black;
`

const Description = styled.div`
  width: 100%;
  overflow: hidden;
  font-size: 14px;
  line-height: 21px;
  color: rgb(108, 111, 116);
`

type IProps = WidgetCardBaseProps & {
  card: PostWidgetCard
}

const Post = (props: IProps) => {
  const { card, locale } = props

  if (!Boolean(MobilityHelper.getTranslation(locale, card.translations, 'title'))) return null

  const coverImageUrl = MobilityHelper.getTranslation(locale, card.translations, 'cover_image_url')
  const title = MobilityHelper.getTranslation(locale, card.translations, 'title')
  const description = MobilityHelper.getTranslation(locale, card.translations, 'summary')
  const url = MobilityHelper.getTranslation(locale, card.translations, 'url')

  return (
    <Container href={url} target="_blank" rel="noreferrer">
      {coverImageUrl && <Cover>
        <img src={coverImageUrl} />
      </Cover>}

      <Section>
        <Content>
          <Title>{title}</Title>
          <Description>{description}</Description>
        </Content>
      </Section>
    </Container>
  )
}

export default Post